import { render, staticRenderFns } from "./groups-add.vue?vue&type=template&id=a52137f2&"
import script from "./groups-add.vue?vue&type=script&lang=js&"
export * from "./groups-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports